import { createSelector } from "reselect"
import { IAddin, IAddins } from "./index"

const getAddins = (state: IAddins): IAddin[] => state.addins

export const getSortedAddins = createSelector([getAddins], (addins): IAddin[] =>
    addins.sort((a, b) =>
        a.addInName
            .toLocaleUpperCase()
            .localeCompare(b.addInName.toLocaleUpperCase()),
    ),
)
